import React from 'react'
import './SearchPage.css'
import TuneOutlinedIcon from '@material-ui/icons/TuneOutlined';
import ChannelRow from './ChannelRow';
import VideoRow from './VideoRow';

function SearchPage() {
  return (
    <div className='searchPage'>
        <div className='searchPage__filter'>
            <TuneOutlinedIcon/>
            <h2>FILTER</h2>
        </div>
        <hr/>

        <ChannelRow
         image = 'https://yt3.ggpht.com/RzshWeKWZ7m-n9wfQ9jLKIyCJwmxYMp1V76Qg7wUjDDIhWVHidzyYo_stpAC3DdhzoAsDyygAlI=s176-c-k-c0x00ffffff-no-rj-mo'
         channel = 'Mayuri Nimonkar'
         verified 
         subs = '4M'
         noOfVideos = '4'
         description = 'Welcome! This is the place where I post my Music! :)'
         />

        <hr/>

        <VideoRow
         views = '4M'
         subs = '1M'
         description = 'Hello all! This divine song has been my personal favourite since childhood! :) Making a version of this song has been truly a ...'
         timestamp = '2 years ago'
         channel = 'Mayuri Nimonkar'
         title = 'Ekadantaya Vakratundaya | Female Version |Mayuri Nimonkar|Rashmi Ruikar'
         image = 'https://i.ytimg.com/an_webp/y0OvmSordYU/mqdefault_6s.webp?du=3000&sqp=CLab8ZUG&rs=AOn4CLB8eD7hTcAsfkCypG_Re2n9FjEXUw'
        />

    </div>
  )
}

export default SearchPage